
import {
  Vue, Component,
} from 'vue-property-decorator';
import EditLeadDetailsDialog from '@/components/EditLeadDetailsDialog.vue';
import LeadCategoriesAndTags from '@/components/LeadCategoriesAndTags.vue';
import { PermissionCode, User } from '@/types';

@Component({
  components: {
    EditLeadDetailsDialog,
    LeadCategoriesAndTags,
  },
})
export default class LeadDetails extends Vue {
  editDialog = false

  get categories() {
    return this.$store.getters.categories;
  }

  get tags() {
    return this.$store.getters.tags;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions() {
    return this.$store.getters.currentUserPermissions;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get isRequester() {
    return this.user && this.lead && this.user.id === this.lead.requesterId;
  }

  get isEditable() {
    if (!this.lead) return false;

    return this.lead
      && 'status' in this.lead
      && (this.lead.status === 'open' || this.lead.status === 'new' || this.lead.status === 'cancelled')
      && (this.isRequester || this.hasPermission('leads.modify_categories') || this.hasPermission('leads.modify_tags'));
  }

  get hasCategories() {
    return this.lead && typeof this.lead.flatCategories === 'string' && this.lead.flatCategories.length > 2;
  }

  get hasTags() {
    return this.lead && typeof this.lead.flatTags === 'string' && this.lead.flatTags.length > 2;
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onEdit() {
    if (!this.isEditable) return;

    this.editDialog = true;
  }
}
